import { createReducer, on } from '@ngrx/store';

import { OptionSheetViewActions } from '../sheet-view-core/sheet-view.actions';
import { sheetViewInitialState } from '../sheet-view-core/sheet-view.state';

export const sheetViewReducer = createReducer(
    sheetViewInitialState,
    on(OptionSheetViewActions.openOptionSheetView, (state, action) => {
        return {
            ...state,
            isOpen: true,
            optionGroupId: action.payload.sourceOptionGroup?.id!,
        };
    }),

    on(OptionSheetViewActions.closeOptionSheetView, () => ({
        ...sheetViewInitialState,
        sourceOptionGroup: undefined,
    })),
);
